import { addCommunityMember } from "./addCommunityMember";
import { removeCommunityMember } from "./removeCommunityMember";

export const addCommunityMemberToAccessGroup = addCommunityMember;
export const removeCommunityMemberFromAccessGroup = removeCommunityMember;
